import { Link } from "react-router-dom";
import { mangaSeries } from "@/mocks/manga";

const heroImage =
  "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20vibrant%20sunrise%20over%20a%20fantasy%20skyline%20with%20floating%20open%20comic%20books%20and%20dynamic%20energy%20streaks%2C%20warm%20orange%20red%20and%20gold%20color%20palette%2C%20heroic%20hopeful%20mood%2C%20clean%20artistic%20composition%20with%20soft%20glow%2C%20editorial%20illustration%20style&width=1600&height=900&seq=manga-hero-01&orientation=landscape";

const todayCount = mangaSeries.filter((m) => m.isToday || m.isNew || m.isBackfill).length;

const stats = [
  { label: "今日更新", value: `${todayCount} 部`, icon: "ri-flashlight-line" },
  { label: "连载漫画", value: "1200+", icon: "ri-book-open-line" },
  { label: "追更读者", value: "860万", icon: "ri-group-line" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="66漫画网 热血漫画更新动态背景图"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/55"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <i className="ri-flashlight-fill text-accent-400"></i>
            最新话抢先看 · 追更必备
          </span>
          <h1 className="mt-6 font-display text-3xl leading-tight text-background-50 md:text-5xl">
            66漫画网
            <span className="mt-2 block text-xl text-accent-300 md:text-3xl">
              更新动态实时掌握，追更不再错过
            </span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            实时了解66漫画网最新话、今天更新、补更与断更动态，一键查看追更进度，轻松掌握每部连载漫画的更新状态。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/updates"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看更新动态
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/series"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/50 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
            >
              <i className="ri-book-2-line"></i>
              进入追更书架
            </Link>
          </div>
        </div>

        <div className="mt-12 grid max-w-2xl grid-cols-3 gap-3 sm:gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-50/20 bg-foreground-950/30 p-4 text-center backdrop-blur"
            >
              <i className={`${s.icon} text-accent-400 text-xl`}></i>
              <p className="mt-2 font-display text-xl text-background-50 md:text-2xl">{s.value}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}